import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor() {}

  isNullOrEmpty(myString: string): boolean {
    return myString == null || myString.trim() === '';
  }
  objectToQueryString(obj: any) {
    let str = [];
    for (let p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    }
    return str.join('&');
  }
  getErrorMessage(err: any): string {
    let errorMessage = '';
    try {
      let error = JSON.parse(err);
      if (typeof error === 'object') {
        errorMessage = '<ul>';
        for (const property in error) {
          if (error.hasOwnProperty('message')) {
            errorMessage = error['message'];
            let errorArray = errorMessage.split('-> ');
            if (Array.isArray(errorArray)) {
              errorMessage = '<ul>';
              errorArray.forEach((errorItem) => {
                errorMessage += '<li>' + errorItem + '</li>';
              });
            }
            break;
          } else {
            let errorArray = error[property];
            if (Array.isArray(errorArray)) {
              errorArray.forEach((errorItem) => {
                errorMessage += '<li>' + errorItem + '</li>';
              });
            }
          }
        }
        if (errorMessage.indexOf('<ul>') >= 0) {
          errorMessage += '</ul>';
        }
      }
    } catch {
      const body = err?.error;
      const unreachable =
        err?.status === 0 ||
        (typeof ProgressEvent !== 'undefined' &&
          (err instanceof ProgressEvent || body instanceof ProgressEvent));
      if (unreachable) {
        return 'Unable to reach the policies API.';
      }
      if (typeof body === 'string' && body) {
        return body;
      }
      if (body && typeof body.message === 'string') {
        return body.message;
      }
      if (typeof err === 'string') {
        return err;
      }
      if (typeof err?.message === 'string') {
        return err.message;
      }
      if (typeof err?.status === 'number' && err.status) {
        return `Request failed (${err.status}).`;
      }
      return 'Something went wrong.';
    }
    return errorMessage;
  }
}
